module.exports = __webpack_public_path__ + "img/logo-min-dark.876349ce.png";